/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 18:32:47
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-30 10:27:47
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/ContentGroup/EDM/index.tsx
 */
import React from 'react';

import css from './css.less';

import GreenLink from 'src/components/Link/GreenText';
import LeftGreenBlock from 'src/components/DragContainers/LeftGreenBlock';
import { IParams } from 'src/pages/SalesChannelContentEditor/common';
import { useParams } from 'react-router-dom';

const EDMHeader = (props) => {
  return (
    <LeftGreenBlock blockHeight={48}>
      <div className={css.edmHeader}>EDM (Electronic Direct Mail)</div>
    </LeftGreenBlock>
  );
};
const EDMBody = (props) => {
  const _params: IParams = useParams();
  const { contentUuid, saleChannelUuid } = _params;

  return (
    <div className={css.body}>
      <GreenLink
        to={`/salesChannel/editor/content/promotion/${saleChannelUuid}/${contentUuid}`}>
        Edit in Promotion Page
      </GreenLink>
    </div>
  );
};
export { EDMHeader, EDMBody };
